import {
  Component,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Report } from '@app/modules/reports/types/report.types';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-approve-report',
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './approve-report.component.html',
})
export class ApproveReportComponent {
  public report = input<Report>();
  public kitId = input<string>();
  public approveReport = output<boolean>();

  protected cancel() {
    this.approveReport.emit(false);
  }

  protected onApproveReport() {
    this.approveReport.emit(true);
  }
}
